import React from 'react';

import { FormattedMessage } from 'react-intl';

const IwFormattedMessage = ({
    id,
    defaultMessage,
    values = {},
    tagName: TagName = 'span',
    className,
    ...tagProps
}) => (
    <FormattedMessage
        id={id}
        defaultMessage={defaultMessage || id}
        values={values}>
        {/*
            Needs destructuring to work as showcased in this test:
            https://github.com/formatjs/formatjs/blob/96a11032768fb3087dcdbe5be0b9e0ba90accb89/test/unit/components/message.js#L267-L292
        */}
        {(...txt) => (
            <TagName className={className} {...tagProps}>
                {txt}
            </TagName>
        )}
    </FormattedMessage>
);

export default IwFormattedMessage;
